<template>
  <div class="bread" :class="{ 'is-bg': isBg }">
    <el-page-header v-if="parentName" @back="goBack" :content="title"></el-page-header>
    <div v-else class="bread-title">{{ title }}</div>
    <div v-if="tips" class="handle-btn-tip">&ensp;{{tips}}</div>
    <div class="bread-btn">
      <slot></slot>
    </div>
    <div v-if="isBack" @click="back" class="bread-header-back">返回</div>
  </div>
</template>

<script>
export default {
  name: "Bread",
  props: {
    title: {
      type: String,
      required: true,
    },
    parentName: {
      type: String,
    },
    // 页面提示说明
    tips: {
      type: String,
      required: true,
    },
    /**
     * 返回：（isBack是 -1：返回上一级，是连接：返回某个链接地址）
     */
    isBack: {
      type: String,
    },
    breadData: {
      type: Array,
      default: () => [],
    },
    isBg: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: this.parentName })
    },
    back() {
      if (this.isBack == '-1') {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: this.isBack })
      }
    }
  }
};
</script>

<style lang="scss">
.bread {
  display: flex;
  align-items: center;
  line-height: 20px;
  padding: 14px 20px;
  &.is-bg {
    padding: 0 0px 15px 0px;
  }

  .bread-title {
    position: relative;
    padding-right: 21px;
    font-size: 18px;
    flex: 1;
  }
  .bread-header-back {
    margin-left: 10px;
    width: 68px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #009021;
    color: #009021;
    cursor: pointer;
    text-align: center;
    line-height: 30px;
  }
  .handle-btn-tip {
    color: #909399;
  }
}
</style>

